import { Box, CircularProgress } from "@material-ui/core";
import React from "react";
import { createPortal } from "react-dom";
import style from "./loader-with-overlay.module.scss";

export const LoaderWithOverlay = () => {
  return createPortal(
    <div className={style.root}>
      <CircularProgress />
    </div>,
    document.getElementById("loader-root")!
  );
};
